export const UPDATE_ROL = 'UPDATE_ROL';
export const RESET_ROL = 'RESET_ROL';